import { ReactElement } from 'react';
import classnames from 'classnames';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';

import { Order } from '~/types';
import { IHospitalEventList } from '~/services/api/hospital/types';
import { getSort } from '~/utils/sort';
import { ISort } from '~/utils/sort/types';
import NoDataFound from '~/ui/components/reusable/NoDataFound';
import Item from './Item';
import { headCells } from './constants';
import styles from './Table.module.scss';

interface IProps {
  events: IHospitalEventList[];
  sort: ISort;
  onSort: (sort: ISort) => void;
  onOpenDetails: (event: IHospitalEventList) => void;
}

const TableComponent = ({ events, sort, onSort, onOpenDetails }: IProps): ReactElement => (
  <TableContainer>
    <Table>
      <TableHead>
        <TableRow>
          {headCells.map(headCell => (
            <TableCell
              key={headCell.id}
              width={headCell.width}
              className={classnames({ [styles.cellCenter]: headCell.id === '' })}
            >
              {headCell.useSort ? (
                <TableSortLabel
                  active={sort.orderBy === headCell.id}
                  direction={
                    sort.orderBy === headCell.id && sort.isDescending ? Order.Desc : Order.Asc
                  }
                  onClick={() => onSort(getSort(sort, headCell.id))}
                >
                  {headCell.label}
                </TableSortLabel>
              ) : (
                headCell.label
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {events.length ? (
          events.map(item => <Item key={item.id} event={item} onOpenDetails={onOpenDetails} />)
        ) : (
          <TableRow>
            <TableCell colSpan={7}>
              <NoDataFound />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TableComponent;
